import { Drawer } from "antd";
import { GeneralStore } from "../stores";
import { MainSidebarItems, ProfileDropdown } from "../sharedComponents";

export const MobileSidebar = () => {
 const { mobileSidebarOpen, setMobileSidebarOpen } = GeneralStore();
 return (
  <Drawer
   className="md:hidden "
   zIndex={4000}
   open={mobileSidebarOpen}
   onClose={() => setMobileSidebarOpen(false)}
   placement="left"
   width={220}
   styles={{
    body: {
     padding: 0,
    },
    header: {
     display: "none",
    },
    footer: {
     display: "none",
    },
   }}
  >
   <div className="h-[100vh] overflow-hidden flex flex-col justify-between">
    <div className="h-full overflow-y-auto">
     <MainSidebarItems />
    </div>
    <ProfileDropdown />
   </div>
  </Drawer>
 );
};
